import { KV, KVRow } from '../components/KV';
import {
  selected_option_id,
  type ConfigPayload,
  type ConfigValue,
  type SelectField,
} from './types';

// Renders a SelectField as one dropdown that writes one-or-more config keys. The current
// selection is derived from the config values (not a single key), and changing it emits the
// chosen option's full `set` map for the form to merge. Mirrors ToggleField's layout
// (KV row + muted description) so the two field kinds sit together cleanly.
export default function SelectFieldRow({
  field,
  values,
  on_change,
}: {
  field: SelectField;
  values: ConfigPayload;
  on_change: (set: Record<string, ConfigValue>) => void;
}) {
  const current = selected_option_id(field, values);
  const selected = field.options.find((o) => o.id === current);

  return (
    <div style={{ display: 'grid', gap: 4 }}>
      <KV>
        <KVRow
          label={field.label}
          value={
            <select
              value={current}
              title={field.description}
              onChange={(e) => {
                const opt = field.options.find((o) => o.id === e.target.value);
                if (opt) on_change(opt.set);
              }}
            >
              {field.options.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.label}
                </option>
              ))}
            </select>
          }
        />
      </KV>
      {field.description && (
        <p className="muted" style={{ fontSize: 12, margin: 0 }}>
          {field.description}
        </p>
      )}
      {selected?.description && (
        <p className="muted" style={{ fontSize: 12, margin: 0, fontStyle: 'italic' }}>
          {selected.description}
        </p>
      )}
    </div>
  );
}
